/* ==============================================================
   Mana.jam — Brinde por valor de compra
   Web component <manajam-gift-auto-add> (renderizado no theme.liquid).
   Adiciona o brinde sozinho quando o subtotal elegível atinge a meta
   e remove quando cai abaixo. O preço R$0 é garantido pelo desconto
   automático "Compre X Ganhe Y" no admin — se o desconto sumir, o
   guard abaixo remove o brinde em vez de deixá-lo cobrado.
   ============================================================== */
(function () {
  if (window.customElements.get('manajam-gift-auto-add')) return;

  var GIFT_PROP = '_brinde';

  class ManajamGiftAutoAdd extends HTMLElement {
    connectedCallback() {
      if (window.Shopify && window.Shopify.designMode) return; // não roda no theme editor
      this.variantId = parseInt(this.dataset.variantId, 10) || 0;
      this.threshold = parseInt(this.dataset.threshold, 10) || 0;
      this.available = this.dataset.available === 'true';
      this.inFlight = false; // 1 request por vez; o cartUpdate seguinte reavalia
      this.cooldown = false; // desliga após falha (ex.: sem estoque) até reload
      if (!this.variantId || this.threshold <= 0) return;

      this.onCartUpdate = this.onCartUpdate.bind(this);
      if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
        window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, this.onCartUpdate);
      }
      this.fetchAndEvaluate(); // estado inicial (gaveta pode nem estar aberta)
    }

    onCartUpdate(payload) {
      var cart = payload && payload.cart;
      // /cart/add.js responde só com os itens adicionados (sem total_price)
      if (cart && typeof cart.total_price === 'number' && Array.isArray(cart.items)) {
        this.evaluate(cart);
      } else {
        this.fetchAndEvaluate();
      }
    }

    fetchAndEvaluate() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then((cart) => { this.evaluate(cart); })
        .catch(function () {});
    }

    evaluate(cart) {
      if (this.inFlight || this.cooldown || !cart || !Array.isArray(cart.items)) return;

      var giftLines = cart.items.filter((item) => {
        return item.id === this.variantId && item.properties && item.properties[GIFT_PROP];
      });

      // A meta é medida SEM o valor do brinde: se o desconto estiver quebrado,
      // o brinde a preço cheio não pode sustentar o próprio threshold.
      var giftValue = giftLines.reduce(function (sum, item) {
        return sum + (item.final_line_price || 0);
      }, 0);
      var eligible = cart.total_price - giftValue;

      // Guard financeiro: brinde aparecendo COBRADO (desconto apagado ou
      // dessincronizado) é removido na hora — o cliente nunca paga por ele.
      var charged = giftLines.some(function (item) {
        return (item.final_line_price || 0) > 0;
      });
      if (charged) {
        this.cooldown = true;
        return this.removeGift(giftLines);
      }

      if (eligible >= this.threshold && giftLines.length === 0) {
        if (this.available) this.addGift();
        return;
      }
      if (eligible < this.threshold && giftLines.length > 0) return this.removeGift(giftLines);
      if (giftLines.length > 1 || (giftLines.length === 1 && giftLines[0].quantity > 1)) {
        return this.normalizeGift(giftLines);
      }
    }

    getSections() {
      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );
      return sections;
    }

    request(url, body) {
      this.inFlight = true;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then((response) => {
          this.inFlight = false;
          if (response && (response.status || response.errors)) {
            this.cooldown = true;
            return;
          }
          if (window.MinimogEvents && window.MinimogTheme) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
          }
        })
        .catch(() => {
          this.inFlight = false;
          this.cooldown = true;
        });
    }

    addGift() {
      var props = {};
      props[GIFT_PROP] = 'true';
      var routes = (window.MinimogSettings && window.MinimogSettings.routes) || {};
      this.request(routes.cart_add_url || '/cart/add.js', {
        items: [{ id: this.variantId, quantity: 1, properties: props }],
        sections: this.getSections().join(','),
        sections_url: window.location.pathname,
      });
    }

    removeGift(giftLines) {
      var routes = (window.MinimogSettings && window.MinimogSettings.routes) || {};
      // remove por key (imune a reordenação); linhas extras caem na próxima avaliação
      this.request(routes.cart_change_url || '/cart/change.js', {
        id: giftLines[0].key,
        quantity: 0,
        sections: this.getSections().join(','),
        sections_url: window.location.pathname,
      });
    }

    normalizeGift(giftLines) {
      var routes = (window.MinimogSettings && window.MinimogSettings.routes) || {};
      this.request(routes.cart_change_url || '/cart/change.js', {
        id: giftLines[0].key,
        quantity: 1,
        sections: this.getSections().join(','),
        sections_url: window.location.pathname,
      });
    }
  }

  window.customElements.define('manajam-gift-auto-add', ManajamGiftAutoAdd);
})();
